<template>
	<a-modal class="client-modal-wrapper hospital-modal" :destroy-on-close="true" width="702px" :mask-closable="false"
		:visible="hospitalVisible" :footer="null" :title="title" @cancel="$emit('onCancel')">
		<basic-form ref="basicForm" :form-data="formData">
			<template #name>
				<a-input v-decorator="['name',{ rules: [{ required: true, message: '请选择医院' }] }]" style="width: 80%"
					placeholder="请输入医院名称" @change="handleChange" />
				<a-button type="primary" style="margin-left:10px" @click="seach_hospital">
					搜索
				</a-button>
				<ul v-show="seach" class="select-wrapper">
					<a-spin v-if="infoLoading" style="margin:6px;" />
					<li v-for="(item,index) in seach_hospital_list" :key="index" class="select-item"
						@click="select_hospital(index)">
						{{ item.hosName }}
					</li>
				</ul>
			</template>
			<template #hospital_grade>
				<grade-input-select v-decorator="[
            'hospital_grade',
            { rules: [{ required: true, message: '请选择级别' }] }
          ]" :grade-data="hospital_grade" />
			</template>
			
			<template #map>
				<coordinatePick ref="coordinatePickRef" @lngLatChange="lngLatChange"></coordinatePick>
			</template>
			
			
		</basic-form>
		<slot />
	</a-modal>
</template>

<script>
	import {
		getSelectData,
		getProvinceData
	} from './../utils/index';
	import ClientProvinceCity from '../components/ProvinceCity';
	import coordinatePick from '@/components/coordinatePick'
	export default {
		components: {
			ClientProvinceCity,
			coordinatePick
		},
		props: ['hospitalVisible', 'formData', 'title', 'type'],
		data() {
			return {
				infoLoading: true,
				seach: false,
				seach_hospital_list: [],
				keyword: '',
				isHospital: false,
				isDrugs: false,
				hospital_name: [], // 医院名称
				hospital_grade: {
					title: '级别',
					placeholder: '请选择级别',
					data: [],
				},

				hospital_level: {
					title: '等别',
					placeholder: '请选择等别',
					data: [],
				},
				hospital_class: {
					title: '类别',
					placeholder: '请选择类别',
					data: [],
				},
				hospital_nature: {
					title: '性质',
					placeholder: '请选择性质',
					data: [],
				},
				hospital_property_right_nature: {
					title: '产权性质',
					placeholder: '请选择产权性质',
					data: [],
				},
				hospital_profit_nature: {
					title: '盈利性质',
					placeholder: '请选择盈利性质',
					data: [],
				},
				// 药店
				drugstore_kind: {
					placeholder: '请选择类型',
					data: [],
				},
				institution_kind: {
					placeholder: '请选择类型',
					data: [],
				},
				companyData: [],
			};
		},
		mounted() {
			this.getConfig();
			this.getCompanyList();
		},
		methods: {
			lngLatChange(lnglat) {
				console.log(lnglat) // 这里就是返回的用逗号拼接好的经纬度坐标
			},
			// 选中的医院资料
			select_hospital(i) {
				let selhospital = this.seach_hospital_list[i];
				console.log(selhospital);
				this.seach = false;
				this.$refs.basicForm.form.setFieldsValue({
					name: selhospital.hosName
				});
			},
			// 搜索医院
			async seach_hospital() {
				if (!this.keyword) {
					this.$message.warning('请输入关键词！');
					return;
				}
				this.infoLoading = true;
				this.seach_hospital_list = [];
				this.seach = true;
				let result = await this.$http.post('/system/get_country_hospital_list', {
					'keyword': this.keyword
				});
				if (result.data.status === 1) {
					this.infoLoading = false;
					if (result.data.data.length > 0) {
						this.seach_hospital_list = result.data.data;
					} else {
						this.seach_hospital_list = [{
							hosName: '暂无数据'
						}];
					}
				}
			},
			// 关键字
			handleChange(e) {
				this.keyword = e.target.value;
				console.log('handleChange -> this.keyword', this.keyword);
			},
			// // 获取全国医院
			// async getConfig() {
			//   let result = await this.$http.post('/system/getConfigs');
			//   if (result.data.status === 1) {
			//     let res = result.data.data;
			//     this.hospital_name = res.list;
			//   }
			// },
			// 获取医院级别
			async getConfig() {
				let result = await this.$http.post('/system/getConfigs');
				if (result.data.status === 1) {
					let res = result.data.data;
					this.hospital_grade.data = getSelectData(res.hospital_grade);
					this.hospital_level.data = getSelectData(res.hospital_level);
					this.hospital_class.data = getSelectData(res.hospital_class);
					this.hospital_nature.data = getSelectData(res.hospital_nature);
					this.hospital_property_right_nature.data = getSelectData(
						res.hospital_property_right_nature
					);
					this.hospital_profit_nature.data = getSelectData(
						res.hospital_profit_nature
					);
					this.drugstore_kind.data = getSelectData(res.drugstore_kind);
					this.institution_kind.data = getSelectData(res.institution_kind);
				}
			},
			// 获取合作企业
			async getCompanyList() {
				let result = await this.$http.post('/Company/getCooperationCompanyList');
				if (result.data.status === 1) {
					this.companyData = result.data.data.data_list;
				}
			},
			// 自定义省市校验
			checkProvinceCity(rule, value, callback) {
				const error = [];
				if (!value || !value.province) {
					error.push('省份');
				}
				if (value.province > 4) {
					if (!value || !value.city) {
						error.push('城市');
					}
				} else {
					value.city = '';
				}
				if (error.length === 0) {
					callback();
				}
				callback(`请选择${error.join('和')}`);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.client-modal-wrapper {
		.textarea {
			font-size: 12px;
			font-weight: 400;
			color: rgba(86, 92, 102, 1);
			position: relative;
			top: -37px;
			right: -550px;
		}

		.select-wrapper {
			width: 392px;
			max-height: 250px;
			min-height: 30px;
			z-index: 100;
			position: absolute;
			padding: 0;
			background: #fff;
			border-radius: 4px;
			overflow: auto;
			margin-top: 2px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			transition: all 0.3s;

			.select-item {
				line-height: 15px;
				list-style: none;
				padding: 7px 10px;
				margin: 0;
				cursor: pointer;

				&:hover {
					background: #e6f7ff;
				}
			}
		}
	}
</style>
